import { SelectableFilterQueryBase } from "models/common/selectableFilterQueryBase";


export interface DashboardWidgetsFilterQuery extends SelectableFilterQueryBase {
    fromLastModified?: string;
    widgets?: TileType[];
}

export enum TileType {
    AverageBasket = "AverageBasket",
    CustomerStats = "CustomerStats",
    DatabaseStats = "DatabaseStats",
    GeneralStats = "GeneralStats",
    NegativeSoh = "NegativeSoh",
    OptimalBrands = "OptimalBrands",
    PendingPriceChanges = "PendingPriceChanges",
    SalesNegativeGP = "SalesNegativeGP",
    StocksCreatedAtStore = "StocksCreatedAtStore",
    TotalGP = "TotalGP",
    TotalInvoices = "TotalInvoices",
    TotalSales = "TotalSales",
    TotalScripts = "TotalScripts"
}